import { getToken } from "@/helpers/cookiesHelper";
import { useNavigate } from "react-router-dom";

export const RequireAuth = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const token = getToken();

  const handleClick = (e: React.MouseEvent) => {
    if (!token) {
      e.preventDefault();
      e.stopPropagation();
      navigate("/login");
    }
  };

  return <div onClick={handleClick}>{children}</div>;
};
